import React, { useState } from "react";
import { authUser } from "components/misc/login/auth-handler";
import "./LoginmaskStyle.css";

const Loginmask = ({ loginSetter, rootId }) => {
  const errorMessage = "Benutzername oder Passwort ist ungültig";
  const [displayError, setDisplayError] = useState("");

  const handleSubmit = async (event) => {
    // Prevent page reload
    event.preventDefault();

    // Fetches values from form in html doc
    var { uname, pass } = document.forms[rootId];

    try {
      await authUser(uname.value, pass.value);
      loginSetter(true);
    } catch (error) {
      renderErrorMessage(errorMessage);
    }
  };

  const renderErrorMessage = (message) => {
    setDisplayError(message);
  };

  const renderForm = () => {
    return (
      <div>
        {displayError !== "" ? (
          <div className="error">
            <span>{displayError}</span>
          </div>
        ) : (
          ""
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <label>Benutzername</label>
            <input type="text" name="uname" required />
          </div>
          <div className="input-container">
            <label>Password</label>
            <input type="password" name="pass" required />
          </div>
          <div className="button-container">
            <input type="submit" />
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="loginmask">
      <div className="login-form">
        <h3>Login</h3>

        <p className="login-note">
          Loggen Sie sich bitte mit ihren RZ-Zugangsdaten ein, um die
          hinterlegten Funktionen einsehen zu können.
        </p>

        {/*
        <p className="login-note">
          Bitte beachten Sie, dass ein Login nur im Campusnetz funktioniert.
        </p>
        */}

        {renderForm()}
      </div>
    </div>
  );
};

export default Loginmask;
